import React from 'react';
import Joi from 'joi-browser';
import { toast } from 'react-toastify';
import http from '../../services/httpService';
import Form from '../common/form';
import Spinner from '../common/spinner';

class RegisterForm extends Form {
	state = {
		data: {
			referralID: this.props.referralID || '',
			email: '',
			password: '',
			password_confirmation: '',
		},
		errors: {},
		matched: false,
		ul: false,
		alhpanumer: false,
		length: false,
		isCheckBtnLoading: false,
		idStatus: 0,
		afterCheckMessage: 'Press Check button to examine the entered ID.',
	};

	classesByIDStatus = [
		{ text: 'danger', icon: 'times' },
		{ text: 'primary', icon: 'info' },
		{ text: 'success', icon: 'check' },
	];

	schema = {
		referralID: Joi.string()
			.allow('')
			.alphanum()
			.min(8)
			.max(10)
			.lowercase()
			.label('Referral ID'),
		email: Joi.string().email().required().label('Email'),
		password: Joi.string().required().min(8).max(26).label('Password'),
		password_confirmation: Joi.string().required().min(8).max(26).label('Confirm password'),
	};

	doSubmit = () =>
		this.props.onSubmit({
			...this.state.data,
			...{ idStatus: this.state.idStatus },
		});

	checkIDHandler = async () => {
		const { referralID } = this.state.data;
		// if (!referralID) return;

		try {
			this.setState({ isCheckBtnLoading: true });
			const { data } = await http.checkID({
				referralID: referralID.toLowerCase(),
			});
			const errors = { ...this.state.errors };
			delete errors.referralID;
			this.setState({
				errors,
				afterCheckMessage: data.message,
				idStatus: data.idStatus,
			});
		} catch (ex) {
			console.log(ex);
			if (ex.response && ex.response.status === 400) {
				const data = ex.response.data;
				return this.setState({
					afterCheckMessage: data,
					idStatus: 0,
				});
			}
			if (ex && ex.response && ex.response.data) {
				this.setState({ idStatus: 0 });
				return toast.error(ex.response.data);
			}
			if (ex && ex.message) {
				this.setState({ idStatus: 0 });
				return toast.error(ex.message);
			}
		} finally {
			this.setState({ isCheckBtnLoading: false });
		}
	};

	onReferralIDChanged = () => {
		this.setState({
			afterCheckMessage: 'Press Check button to examine the entered ID.',
			idStatus: 0,
		});
	};

	checkPassword = ({ currentTarget: text }) => {
		const hasAlpha = (str) => /[a-zA-Z- ]+/.test(str);
		const hasNum = (str) => /[0-9]+/.test(str);

		const textLength = text.value.length;
		const length = textLength >= 8 && textLength <= 26 ? true : false;
		const ul =
			text.value.toUpperCase() !== text.value && text.value.toLowerCase() !== text.value
				? true
				: false;
		const alhpanumer = hasAlpha(text.value) && hasNum(text.value);
		this.setState({ length, ul, alhpanumer });
	};

	checkPasswordsMatched = ({ currentTarget }) => {
		const id = currentTarget.id;
		const targetID = id === 'password' ? 'password_confirmation' : 'password';
		const text = currentTarget.value;
		const target = this.state.data[targetID];
		this.setState({ matched: text === target });
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.errors !== this.props.errors) {
			const state = { ...this.state };
			state.errors = this.props.errors;
			this.setState(state);
		}
	}

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, theme } = this.props;
		const {
			errors,
			matched,
			ul,
			alhpanumer,
			length,
			idStatus,
			afterCheckMessage,
			isCheckBtnLoading,
		} = this.state;

		return (
			<form
				autoComplete='off'
				onSubmit={this.handleSubmit}>
				<div className='mb-3'>
					{this.renderInputGroupBtnEnd({
						name: 'referralID',
						label: 'Referral ID',
						type: 'text',
						btnClass: `btn btn-set2-${theme}`,
						extraHandler: this.onReferralIDChanged,
						btnText: isCheckBtnLoading ? (
							<Spinner content={'Checking...'} />
						) : (
							<span>Check</span>
						),
						btnDisable: isCheckBtnLoading || isLoading,
						btnHandler: this.checkIDHandler,
						formText: !errors.referralID && (
							<div
								className={`mx-2 text-my-${this.classesByIDStatus[idStatus].text}`}>
								<i
									className={`fas fa-${this.classesByIDStatus[idStatus].icon} me-1`}></i>
								<span>{afterCheckMessage}</span>{' '}
							</div>
						),
					})}
				</div>
				<div className='mb-3'>
					{this.renderInput({
						name: 'email',
						label: 'Email',
						type: 'text',
					})}
				</div>
				<div className='mb-3'>
					{this.renderInputGroupBtnEnd({
						name: 'password',
						label: 'Password',
						type: 'password',
						btnClass: `btn btn-set2-${theme}`,
						btnText: <i className='fas fa-eye-slash'></i>,
						btnHandler: this.handleEyeClicked,
						formText: (
							<div className='d-flex justify-content-between mx-2'>
								<div className={`text-my-${ul ? 'success' : 'danger'}`}>
									<i className={`fas fa-${ul ? 'check' : 'times'} me-1`}></i>
									Upper & Lower Case
								</div>
								<div className={`text-my-${alhpanumer ? 'success' : 'danger'}`}>
									<i
										className={`fas fa-${
											alhpanumer ? 'check' : 'times'
										} me-1`}></i>
									AlphaNumeric
								</div>
								<div className={`text-my-${length ? 'success' : 'danger'}`}>
									<i className={`fas fa-${length ? 'check' : 'times'} me-1`}></i>
									Length (8to24)
								</div>
							</div>
						),
						extraHandler: (e) => {
							this.checkPassword(e);
							this.checkPasswordsMatched(e);
						},
					})}
				</div>
				<div className='mb-3'>
					{this.renderInputGroupBtnEnd({
						name: 'password_confirmation',
						label: 'Confirm Password',
						type: 'password',
						btnClass: `btn btn-set2-${theme}`,
						btnText: <i className='fas fa-eye-slash'></i>,
						btnHandler: this.handleEyeClicked,
						formText: (
							<div className='d-flex justify-content-between mx-2'>
								<div className={`text-my-${matched ? 'success' : 'danger'}`}>
									<i className={`fas fa-${matched ? 'check' : 'times'} me-1`}></i>
									Passwords Matching
								</div>
							</div>
						),
						extraHandler: this.checkPasswordsMatched,
					})}
				</div>
				<div className='text-center'>
					{this.renderButton(
						'Register',
						`btn btn-lg btn-set2-${theme}`,
						isLoading && <Spinner content={'Registering...'} />
					)}
				</div>
			</form>
		);
	}
}

export default RegisterForm;
